import {Component, Input, EventEmitter, OnInit, Output} from '@angular/core';
import {FlashController} from "../../flash-payment-core/services/flash-controller.service";

@Component({
  selector: 'app-head-form',
  templateUrl: './head-form.component.html',
  styleUrls: ["../../flash-payment.component.sass"]
})
export class HeadFormComponent implements OnInit {
  @Input() billDueDateField: string;
  @Input() billBalanceField: string;
  @Input() pastDueAmountField: string;
  @Input() canUpdateAmount: string;
  @Input() editOperationAmount: string;
  @Input() lastPaymentAmountField: string;
  @Input() isInvoicePayment = false;
  @Input() isPrepaid = false;
  @Input() isInstallment = false;
  prepaidBalance;

  @Output() action = new EventEmitter<any>();
  @Output() action2 = new EventEmitter<any>();

  constructor(public flashPaymentService: FlashController) { }

  ngOnInit(): void {
    this.prepaidBalance = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo[0].prepaidBalanceField
  }

  changeAmount(value = null, edit = false) {
    this.action2.emit({value, edit});
  }

  activateChange(value = null, edit = false) {
    this.action.emit({value, edit});
  }

  goToProcess() {
    window.scroll(0, 1200);
  }

}
